import script from "./BlueprintEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueprintEditor.vue?vue&type=script&setup=true&lang=js"

import "./BlueprintEditor.vue?vue&type=style&index=0&id=52e83d4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52e83d4a"]])

export default __exports__